import { LanguageSwitcher } from "components/LanguageSwitcher";
import { Logo } from "components/Logo";
import { useEffect, useState } from "react";
import { scrollToSection } from "utils/scrollToSection";
import { mobileMenuStyles } from "./mobileMenuStyles";
import { useTranslation } from "react-i18next";
import { navigation } from "config/navigation";

const MobileMenu = () => {
  const { t, i18n } = useTranslation();
  const langPrefix = i18n.language === 'en' ? '' : `/${i18n.language}`;
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenuOpen = () => setIsOpen(!isOpen);

  const {
    button,
    buttonOpen,
    spanBase,
    spanOpenPrimary,
    spanOpenSecondary,
    spanClosed,
    menuContainer,
    menuOpen,
    menuClosed,
    overlay,
    ul,
  } = mobileMenuStyles;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      return;
    }

    document.body.style.overflow = "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <div className="lg:hidden">
      <button
        onClick={toggleMenuOpen}
        aria-label="Toggle mobile menu"
        className={`${button} ${isOpen ? buttonOpen : ""}`}
      >
        <span
          className={`${spanBase} ${
            isOpen ? spanOpenPrimary : spanClosed
          }`}
        />
        <span
          className={`${spanBase} ${
            isOpen ? spanOpenSecondary : spanClosed
          }`}
        />
      </button>
      <div
        className={`${menuContainer} ${isOpen ? menuOpen : menuClosed}`}
      >
        <div className="p-6">
          <div className="md:hidden">
            <Logo />
          </div>
          <ul className={ul}>
            {navigation.mobileItems.map((item) => (
              <li key={item.id}>
                {item.isPage ? (
                  <a
                    href={`${langPrefix}/${item.anchor}/`}
                    onClick={() => toggleMenuOpen()}
                    className={
                      item.id === "creators"
                        ? "font-bold text-[#D6488E]"
                        : undefined
                    }
                  >
                    {t(item.translationKey)}
                  </a>
                ) : (
                  <button
                    onClick={() => {
                      scrollToSection(item.anchor);
                      toggleMenuOpen();
                    }}
                  >
                    {t(item.translationKey)}
                  </button>
                )}
              </li>
            ))}
            <li>
              <LanguageSwitcher isMobileMenuOpen={isOpen} />
            </li>
          </ul>
        </div>
      </div>
      {isOpen && (
        <div
          onClick={toggleMenuOpen}
          className={overlay}
        ></div>
      )}
    </div>
  );
};

export default MobileMenu;
